import script from "./ElementToolbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementToolbar.vue?vue&type=script&lang=ts&setup=true"

import "./ElementToolbar.vue?vue&type=style&index=0&id=2633262b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2633262b"]])

export default __exports__